module.exports = __webpack_public_path__ + "static/img/5_v2.9a9775c2.png";